import React, { useState, useEffect } from "react";
import { Input, Row, Typography, Form, Divider, Card, Table, Col } from "antd";
import appLabel from "../../../../../config/appLabel";

const { Text, Title } = Typography;

const columnsOne = [
  {
    title: "Payment Type",
    dataIndex: "paymentType",
  },
  {
    title: "Fund Source",
    dataIndex: "fundSource",
  },
];

const columnsTwo = [
  {
    title: "Fees",
    dataIndex: "fees",
  },
  {
    title: "Income Account",
    dataIndex: "incomeAccount",
  },
];

const columnsThree = [
  {
    title: "Penalty",
    dataIndex: "penalty",
  },
  {
    title: "Income Account",
    dataIndex: "incomeAccountPenalty",
  },
];

export default function AccountingForm({ casaDetail }) {
  const [accountDetailOne, setAccountDetailOne] = useState([]);
  const [accountDetailTwo, setAccountDetailTwo] = useState([]);
  const [accountDetailThree, setAccountDetailThree] = useState([]);

  console.log(casaDetail);
  useEffect(() => {
    let tempArrayOne = [];
    let tempArrayTwo = [];
    let tempArrayThree = [];
    const fundSourcesforPaymentChannels = casaDetail?.paymentChannelToFundSourceMappings
      ? casaDetail?.paymentChannelToFundSourceMappings
      : ["-"];
    fundSourcesforPaymentChannels.forEach((element) => {
      tempArrayOne.push({
        key: element?.id,
        paymentType: element?.paymentType?.name ? element?.paymentType?.name : "-",
        fundSource: element?.fundSourceAccount?.name ? element?.fundSourceAccount?.name : "-",
      });
    });
    const feestoSpecificIncomeAccount = casaDetail?.feeToIncomeAccountMappings
      ? casaDetail?.feeToIncomeAccountMappings
      : ["-"];

    feestoSpecificIncomeAccount.forEach((element) => {
      tempArrayTwo.push({
        key: element?.id,
        fees: element?.charge?.name ? element?.charge?.name : "-",
        incomeAccount: element?.incomeAccount?.name ? element?.incomeAccount?.name : "-",
      });
    });

    const penaltiestoSpecificIncomeAccount = casaDetail?.feeToIncomeAccountMappings
      ? casaDetail?.feeToIncomeAccountMappings
      : ["-"];
    penaltiestoSpecificIncomeAccount.forEach((element) => {
      tempArrayThree.push({
        key: element?.id,
        penalty: element?.paymentType?.name ? element?.paymentType?.name : "-",
        incomeAccountPenalty: element?.fundSourceAccount?.name
          ? element?.fundSourceAccount?.name
          : "-",
      });
    });
    setAccountDetailOne(tempArrayOne);
    setAccountDetailTwo(tempArrayTwo);
    setAccountDetailThree(tempArrayThree);
  }, []);

  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"  Assests"}
            </Title>
          </Divider>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.casaReference}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.savingsReferenceAccount?.name}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.overdraftPortfolio}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.overdraftPortfolioControl?.name}
              />
            </Form.Item>
          </Col>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"Liabilities"}
            </Title>
          </Divider>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.casaControl}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.savingsControlAccount?.name}
              ></Input>
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.transfersInSupense}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.transfersInSuspenseAccount?.name}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.escheatLiability}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.escheatLiabilityAccount?.name}
              />
            </Form.Item>
          </Col>

          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"Expenses"}
            </Title>
          </Divider>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.interestOnCasa}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.interestOnSavingsAccount?.name}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.writeOff}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.writeOffAccount?.name}
              />
            </Form.Item>
          </Col>

          {/* <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.comissions}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  casaDetail?.accountingMappings?.incomeFromFeeAccount?.name
                }
              />
            </Form.Item>
          </Col> */}

          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"Income"}
            </Title>
          </Divider>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.incomeFromFee}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.incomeFromFeeAccount?.name}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.incomeFromPenalties}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.incomeFromPenaltyAccount?.name}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.overderaftInterestIncome}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.accountingMappings?.incomeFromInterest?.name}
              />
            </Form.Item>
          </Col>
        </Row>
        <Title level={4} style={{ margin: 0 }}>
          Advanced Accounting Rule
        </Title>
        <Divider />
        <Table
          columns={columnsOne}
          dataSource={accountDetailOne}
          bordered
          title={(e) => "Configure Fund Sources for Payment Channels"}
          pagination={{
            position: "bottomCentre",
          }}
        />
        <Table
          columns={columnsTwo}
          dataSource={accountDetailTwo}
          bordered
          title={(e) => "Fees to Specific Income Account"}
          pagination={{
            position: "bottomCentre",
          }}
        />
        {/* <Table
          columns={columnsThree}
          dataSource={accountDetailThree}
          bordered
          title={(e) => "Penalties to Specific Income Account"}
          pagination={{
            position: "bottomCentre",
          }}
        /> */}
      </Card>
    </Form>
  );
}
